<template>
<div class="chapter">
<div class="inner_page">
<div class="_idgenobjectstyleoverride" id="_idContainer1347">
<p class="structure-prep-infos" id="calibre_pb_56">Prep Time: <span class="prep-time-blue">5 minutes</span> • Cooking Time: <span class="prep-time-blue">20 minutes</span> • Makes: <span class="prep-time-blue">2 servings</span></p>
<p class="icon">KETO • paleo •<span class="bold6"> <img alt="" class="_idgenobjectattribute7" src="OEBPS/image/no-glluten.png"/> </span><img alt="" class="_idgenobjectattribute7" src="OEBPS/image/no-dairy.png"/> <img alt="" class="_idgenobjectattribute7" src="OEBPS/image/no-nuts.png"/> </p>
<p class="body_heading-recipe"><span class="heading-red">Mini </span>Meatball Breakfast Hash</p>
<ul class="calibre4">
<li class="body_ingredients">8 ounces organic gro<span>und</span><span> </span><span>turkey</span></li>
<li class="body_ingredients">1 red bell pep<span>per, diced</span></li>
<li class="body_ingredients">6 ounces ba<span>by</span><span> </span><span>spinach</span></li>
<li class="body_ingredients">2 pasture-raised &amp; or<span>ganic</span><span> </span><span>eggs</span></li>
<li class="body_ingredients">1 pound of frozen &amp; thawed caulif<span>lower</span><span> </span><span>rice</span></li>
</ul>
<p class="body_youtube"><img alt="" class="calibre3" src="OEBPS/image/you-tube-black.png"/>To watch the video tutorial for this recipe, search “FlavCity keto hash” on YouTube.</p>
<p class="shopping-tips-left-justified-1col1"><img alt="" class="calibre3" src="OEBPS/image/shopping-tip_white.png"/>	It’s important that the <span class="shopping-tip-bold-red1">turkey</span> is organic. That means they have a non-GMO feed. <span class="shopping-tip-bold-red1">Peppers</span> and <span class="shopping-tip-bold-red1">spinach</span> are always on the dirty dozen, so I would also buy<span> </span>organic.</p>
<p class="shopping-tips-left-justified-1col1"><span class="bold4"> </span><span class="shopping-tip-bold-red1"><img alt="" class="calibre3" src="OEBPS/image/shopping-tip_white.png"/> Frozen cauliflower rice</span> works best for this recipe as it’s too hard to squeeze the water from freshly grated rice. Costco has an incredible deal on a five-pound frozen bag! No need to buy organic because cauliflower is on the clean fifteen<span> </span>list.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 5Ingredient_split_034.vue?8fcd3a8a